import React from 'react';
import CountUp from 'react-countup';
import { NavLink } from 'react-router-dom';

// ========== OPTION A: Video in src/images/ ==========
// Put video2.mp4 inside src/images/ and uncomment this line:
import localVideo from './../../images/video2.mp4';

// ========== OPTION B: Video in public/images/ ==========
// Put video2.mp4 inside public/images/ and comment the import above,
// then uncomment this line:
// const localVideo = '/images/video2.mp4';

var img1 = require('./../../images/video-bg.jpg');

class OurValue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.videoRef = React.createRef();
    }

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }
        loadScript('./assets/js/masonary.js');
    }

    openModal = (e) => {
        if (e) e.preventDefault();
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
        if (this.videoRef.current) {
            this.videoRef.current.pause();
            this.videoRef.current.currentTime = 0;
        }
    };

    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b30 bg-white">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-4 col-sm-12">
                                    {/* TITLE START */}
                                    <div className="section-head">
                                        <div className="mt-separator-outer separator-left">
                                            <div className="mt-separator">
                                                <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Value</h2>
                                            </div>
                                            <p>We support commercial and banking environments with coordinated delivery across construction, interior fit-outs, refurbishment, and technical infrastructure. Our approach is built around quality, schedule control, and a professional handover that supports long-term operations.</p>
                                        </div>
                                    </div>
                                    {/* TITLE END */}
                                    <div className="author-info p-t20">
                                        <div className="author-signature">
                                            <img src={require('./../../images/Signature+Black.png')} alt="Signature" width={150} />
                                        </div>
                                        <div className="author-name">
                                            <h4 className="m-t0">M. Bilal Yasir</h4>
                                            <p>Founder</p>
                                        </div>
                                    </div>
                                    <div className="video-section-full bg-no-repeat bg-cover overlay-wraper" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                                        <div className="overlay-main bg-black opacity-07" />
                                        <div className="video-section-inner">
                                            <div className="video-section-content">
                                                <div className="video-section-left">
                                                    <button type="button" className="play-now" onClick={this.openModal}>
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </button>
                                                </div>
                                                <div className="video-section-right">
                                                    <NavLink to="#" className="font-weight-600 text-uppercase" onClick={this.openModal}>
                                                        Recent Project Video
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-6">
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center bg-dark p-a20">
                                        <div className="counter font-30 font-weight-800 m-b15 text-primary"><CountUp end={70} duration={5} /></div>
                                        <h4 className="m-tb0">Active Experts</h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center bg-dark p-a20">
                                        <div className="counter font-30 font-weight-800 m-b15 text-primary"><CountUp end={60} duration={5} /></div>
                                        <h4 className="m-tb0">Satisfied Clients</h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center bg-dark p-a20">
                                        <div className="counter font-30 font-weight-800 m-b15 text-primary"><CountUp end={594} duration={5} /></div>
                                        <h4 className="m-tb0">Project Complete</h4>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-6">
                                    <div className="p-b0">
                                        <div className="mt-box">
                                            <h3 className="m-t0"><span className="font-weight-100"> We have</span><span className="text-primary"> 25 years</span> experience in construction</h3>
                                        </div>
                                        <span className="progressText text-black"><b>Interior</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={85} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="85%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Commercial</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={78} aria-valuemin={10} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="78%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Construction</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="65%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Building</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={55} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="55%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Architecher</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={40} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="40%" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Custom Modal */}
                {this.state.showModal && (
                    <div className="custom-modal-overlay" onClick={this.closeModal}>
                        <div className="custom-modal-container" onClick={(e) => e.stopPropagation()}>
                            <div className="custom-modal-header">
                                <h5>Video Presentation</h5>
                                <button className="custom-modal-close" onClick={this.closeModal}>×</button>
                            </div>
                            <div className="custom-modal-body">
                                <video
                                    ref={this.videoRef}
                                    controls
                                    autoPlay
                                    width="100%"
                                >
                                    <source src={localVideo} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                )}

                <style>{`
                    .custom-modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.85);
                        z-index: 9999;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .custom-modal-container {
                        background: #000;
                        border-radius: 8px;
                        width: 80%;
                        max-width: 900px;
                    }
                    .custom-modal-header {
                        padding: 15px 20px;
                        border-bottom: 1px solid #333;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    .custom-modal-header h5 {
                        margin: 0;
                        color: #fff;
                    }
                    .custom-modal-close {
                        background: none;
                        border: none;
                        font-size: 28px;
                        cursor: pointer;
                        color: #fff;
                        opacity: 0.7;
                    }
                    .custom-modal-close:hover {
                        opacity: 1;
                    }
                    .custom-modal-body {
                        padding: 0;
                    }
                    @media (max-width: 768px) {
                        .custom-modal-container {
                            width: 95%;
                        }
                    }
                `}</style>
            </>
        );
    }
}

export default OurValue;